import { useState, useEffect, useRef } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import {
  Box,
  IconButton,
  Badge,
  Divider,
  Typography,
  List
} from '@mui/material';
import { useUser } from '../../UserContext';     // your custom hook
import { db } from '../../firebase';            // <-- Import the initialized DB here
import Iconify from '../../components/Iconify';
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';

export default function NotificationsPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  
  // We only need `user` if we're filtering notifications by userId
  const { user } = useUser();

  useEffect(() => {
    if (open && user?.uid) {
      const fetchNotifications = async () => {
        try {
          // 1) Reference the 'notifications' collection
          const notificationsRef = collection(db, 'notifications');

          // 2) Query by user ID
          const q = query(notificationsRef, where('userId', '==', user.uid));
          const querySnapshot = await getDocs(q);

          // 3) Convert documents to an array
          const fetchedNotifications = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
          }));

          setNotifications(fetchedNotifications);
        } catch (error) {
          console.error('Error fetching notifications:', error);
        }
      };

      fetchNotifications();
    }
  }, [open, user?.uid]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const unreadCount = notifications.filter((n) => n.isUnRead).length;

  return (
    <>
      <IconButton ref={anchorRef} size="large" onClick={handleOpen}>
        <Badge badgeContent={unreadCount} color="error">
          <Iconify icon="eva:bell-fill" width={20} height={20} />
        </Badge>
      </IconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current}>
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Typography variant="subtitle1">Notifications</Typography>
        </Box>

        <Divider />

        <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
          <List>
            {notifications.map((notification) => (
              <Typography key={notification.id}>{notification.title}</Typography>
            ))}
          </List>
        </Scrollbar>
      </MenuPopover>
    </>
  );
}
